export { default } from "./ContentCardV2";
